<template>
  <div>
    <h1>Howdy, and hello world</h1>
    <v-row>
      <v-col cols="12" xs="12" sm="12" lg="10">
        <v-card width="100%">
          <v-img :src="require('@/_static/img/background/bag1.jpg')" />
          <v-card-title>Simple Right</v-card-title>
          <v-card-text> Nothing to it but to do it. </v-card-text>
          <v-card-actions>
            <p>
              <v-btn color="primary" to="help"
                >Take a look at the Help Section</v-btn
              >
            </p>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
export default {
  name: "SamplePage",
  mixins: [uiView],
  components: {  },
  props: {},
  watch: {},
  mounted() {
    // this.globalSnackbar = false;
  },
  data: () => ({
    // showNotification: this.globalNotification.snackbar === null ? false : true,
  }),
  methods: {
    dialogOk() {
      alert("Ok");
    },
  },
};
</script>
<style lang="scss">
</style>
